import React, { useState } from "react";

import "./Gallery.css"; // for grid styling
import Slider from "react-slick";
import Image from "../Image/image.js";

const Gallery = ({ event }) => {
  var settings = {
    dots: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    // responsive: [
    //   {
    //     breakpoint: 1500,
    //     settings: {
    //       slidesToShow: 4,
    //       slidesToScroll: 1,
    //     },
    //   },
    //   {
    //     breakpoint: 1200,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 1,
    //     },
    //   },
    //   {
    //     breakpoint: 991,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 1,
    //     },
    //   },
    //   {
    //     breakpoint: 767,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 1,
    //     },
    //   },
    //   {
    //     breakpoint: 480,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //     },
    //   },
    // ],
  };

  return (
    <>
      <Slider {...settings}>
        {event.gallery.map((image, id) => (
          <div className="wpo-team-item" key={id}>
            <div className="wpo-team-img">
              {/* <img src={image} alt="" />  */}
              <Image src={image} border={true} zoom={true}></Image>
            </div>

            {/* { <div className="wpo-team-content"> */}
            {/* { <h2><Link onClick={ClickHandler} to={`/team-single/${Team.id}`}>{Team.name}</Link></h2> } */}
            {/* {<h2>{Team.name}</h2>} */}
            {/* <span>{Team.title}</span> */}
            {/* </div> } */}
          </div>
        ))}
      </Slider>
    </>
  );
};

export default Gallery;
